// import APIs
import { createDutyLineNote } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';

// import types
import { CreateDutyLineNoteMutateParams } from './useCreateDutyLineNote.types';

const useCreateDutyLineNote = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: CreateDutyLineNoteMutateParams) => createDutyLineNote(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useCreateDutyLineNote;
